import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Col, Layout, Row } from 'antd';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import CustomButton from '../../v2-components/Antd/Button';
import MenuOptions from '../../v2-components/MenuOptions';
import MenuProfile from '../../v2-components/MenuProfile';
import { middlewareLogin } from './utils/middleware-login.util';
import NotificationBell from '../../v2-components/NotificationBell';

const Layoutapp = (props) => {
	const [collapsed, setCollapsed] = useState(false);

	if (middlewareLogin(props)) {
		return <>{props.children}</>;
	}

	return (
		<Layout>
			<Layout.Sider theme={'light'} trigger={null} collapsible collapsed={collapsed}>
				<MenuOptions />
			</Layout.Sider>
			<Layout>
				<Layout.Header
					style={{
						fontSize: '16px',
						backgroundColor: '#fff',
					}}
				>
					<Row>
						<Col span={2}>
							<CustomButton
								type="text"
								icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
								onClick={() => setCollapsed(!collapsed)}
							/>
						</Col>

						<Col span={3} offset={18} style={{ display: 'flex', justifyContent:'space-around', alignItems:'center' } }>
							<NotificationBell />
							<MenuProfile />
						</Col>
					</Row>
				</Layout.Header>
				<Layout.Content style={{ height: '100vh' }}>{props.children}</Layout.Content>
			</Layout>
		</Layout>
	);
};

export default withRouter(Layoutapp);
